import React, { FC } from 'react';
import { OfferProps } from '.';
import GlobalTooltip, { Effect, Place } from '../GlobalTooltip';
import Icon from '../Icon';
import { BRAND, ROLES } from '../../constants/main';
import { BrandTypes } from '../../types/brands';
import useTranslations from '@hooks/useTranslations';
import ReactTooltip from 'react-tooltip';

const getIconSize = (brand: BrandTypes) => {
    switch (brand) {
        case BrandTypes.DS:
            return 24;
        default:
            return 16;
    }
};

export const OfferTemplate: FC<OfferProps> = ({
    className,
    text,
    tooltipText,
    iconName,
    id,
    index,
    disableFocus = false,
    place = Place.top,
}): JSX.Element => {
    const { t } = useTranslations();

    return (
        <div className={className}>
            <div className="offer">
                <div>{text}</div>
                <button
                    className="info-icon-container"
                    data-tip={tooltipText}
                    data-for={id}
                    onBlur={(e) => ReactTooltip.hide(e.target)}
                    tabIndex={disableFocus ? -1 : 0}
                >
                    <Icon
                        dataTestId={`TESTING_BENEFIT_${id}`}
                        altId={`svgImgSeeBenefits-${index}`}
                        altText={t('banner.button.learnMore')}
                        name={iconName}
                        height={getIconSize(BRAND as BrandTypes)}
                        width={getIconSize(BRAND as BrandTypes)}
                        role={ROLES.IMG}
                    />
                </button>
                <GlobalTooltip
                    id={id}
                    effect={Effect.solid}
                    place={place}
                    scrollHide={false}
                    event="click"
                    eventOff="mouseout"
                    delayHide={300}
                />
            </div>
        </div>
    );
};
